export const ASSETS_COLLECTION = "assets";
export const ASSETS_COLLECTION_DEV = "assets"; //assets // switch this value for dev
